import { IApiClient } from '~/lib/ApiClient';
import { OperatingSystemStore } from '~/lib/store/OperatingSystemStore';
import { RegionsStore } from '~/lib/store/RegionsStore';
import { VPCStore } from '~/lib/store/VPCStore';
import { SizesStore } from '~/lib/store/SizesStore';
import { SshKeysStore } from '~/lib/store/SshKeysStore';
import { SoftwaresStore } from '~/lib/store/SoftwaresStore';
import { makeObservable } from 'mobx';
import { getAppContext } from '../AppContext';
import { ServiceLevelsStore } from './ServiceLevelsStore';
import { PaymentFrequencyStore } from './PaymentFrequencyStore';

export default class ServerOptionsStore {
    operatingSystems: OperatingSystemStore;
    regions: RegionsStore;
    networks: VPCStore;
    sizes: SizesStore;
    sshKeys: SshKeysStore;
    software: SoftwaresStore;
    serviceLevels: ServiceLevelsStore;
    paymentFrequencies: PaymentFrequencyStore;

    constructor(public apiClient: IApiClient) {
        this.operatingSystems = new OperatingSystemStore(apiClient);
        this.regions = new RegionsStore(apiClient);
        this.networks = new VPCStore(apiClient);
        this.sizes = new SizesStore(apiClient);
        this.sshKeys = new SshKeysStore(apiClient);
        this.software = new SoftwaresStore(apiClient);
        this.serviceLevels = new ServiceLevelsStore(apiClient);
        this.paymentFrequencies = new PaymentFrequencyStore(apiClient);
        makeObservable(this);
    }

    loadAll(serverId?: number, osSlug?: string): Promise<unknown>[] {
        const serviceLevelLoad = getAppContext().isEnabled('ServiceLevel') ? [this.serviceLevels.load()] : [];
        const paymentFrequencyLoad = getAppContext().isEnabled('PaymentFrequency')
            ? [this.paymentFrequencies.load()]
            : [];

        return [
            this.operatingSystems.load(),
            this.regions.load(),
            this.networks.load(),
            this.sizes.loadWithParams(serverId, osSlug),
            this.sshKeys.load(),
            this.software.load(),
            ...serviceLevelLoad,
            ...paymentFrequencyLoad,
        ];
    }

    reloadSizesForOs(osSlug?: string) {
        this.sizes.setOs(osSlug);
    }
}
